import angular from 'angular';
import { geoLocationFactory } from './geoLocation.factory';

export const geoLocationModule = angular
  .module('bit.services.geoLocation', [])
  .factory('geoLocation', geoLocationFactory);
